import React, { Component } from "react";
import "./SubmitButton.less";

class SubmitButton extends Component {
  render() {
    const { disabled = false, children } = this.props;

    return (
      <button className="submit-button" disabled={disabled}>
        {children}
      </button>
    );
  }
}

export default SubmitButton;
